import * as actions from "./actionTypes";
import axios from "../../axios_call";
import { BASE_URL } from "../../components/Helpers/helpers";

const logListStart = () => {
  return {
    type: actions.LOG_LIST_START,
  };
};

const logListFail = (error) => {
  return {
    type: actions.LOG_LIST_FAIL,
    error: error,
  };
};

const logListSuccess = (message, data, page, totalRows) => {
  return {
    type: actions.LOG_LIST_SUCCESS,
    message: message,
    data: data,
    page: page,
    totalRows: totalRows,
  };
};

const logfilterList = (filterText, actionType) => {
  return {
    type: actions.LOG_LIST_FILTER,
    filterText,
    actionType,
  };
};

export const logList = (param) => {
  return (dispatch) => {
    dispatch(logListStart());
    axios
      .get(`${BASE_URL}/log?order=${param.order}&page=${param.page}`)
      .then((response) => {
        if (response.data.status === 200) {
          const rawData = response.data.data;
          const data = Array.isArray(rawData) ? rawData : rawData ? [rawData] : [];
          const msg = response.data.message || 'Success';
          const totalRows = response.data.totalRows || data.length || 1;
          dispatch(logListSuccess(msg, data, param.page, totalRows));
        } else {
          dispatch(logListFail(response.data.message || 'API request failed'));
        }
      })
      .catch((error) => {
        dispatch(logListFail(error.message));
      });
  };
};

export const logListFilter = (filterText, actionType) => {
  return (dispatch) => {
    dispatch(logfilterList(filterText, actionType));
  };
};